import { ExportActionDetailToPdfUseCase } from '@/application/export/exportActionDetailToPdfUseCase';
import { ExportGenericCSVUseCase } from '@/application/export/exportGenericCSVUseCase';
import { ExportStudentRiskReportToPdfUseCase } from '@/application/export/exportStudentRiskReportToPdfUseCase';
import { ExportToPdfUseCase } from '@/application/export/exportToPdfUseCase';
import { academicRiskActionApiRepository } from '@/infra';
import { GenericCSVExportRepositoryImpl } from '@/infra/repositories/genericCSVExport.repository';
import { PdfExportReactPdfRepository } from '@/infra/repositories/pdfExportReactPdf.repository';
import { PdfActionDetailGeneratorService } from '@/infra/services/pdfActionDetailGenerator.service';

let _pdfExportRepository: PdfExportReactPdfRepository | null = null;
let _exportToPdfUseCase: ExportToPdfUseCase | null = null;
let _exportActionDetailToPdfUseCase: ExportActionDetailToPdfUseCase | null =
  null;
let _genericCSVExportRepository: GenericCSVExportRepositoryImpl | null = null;
let _exportGenericCSVUseCase: ExportGenericCSVUseCase | null = null;
let _exportStudentRiskReportToPdfUseCase: ExportStudentRiskReportToPdfUseCase | null =
  null;

export const getPdfExportRepository = (): PdfExportReactPdfRepository => {
  if (!_pdfExportRepository) {
    _pdfExportRepository = new PdfExportReactPdfRepository();
  }
  return _pdfExportRepository;
};

export const getExportToPdfUseCase = (): ExportToPdfUseCase => {
  if (!_exportToPdfUseCase) {
    _exportToPdfUseCase = new ExportToPdfUseCase(getPdfExportRepository());
  }
  return _exportToPdfUseCase;
};

export const getExportActionDetailToPdfUseCase =
  (): ExportActionDetailToPdfUseCase => {
    if (!_exportActionDetailToPdfUseCase) {
      _exportActionDetailToPdfUseCase = new ExportActionDetailToPdfUseCase();
    }
    return _exportActionDetailToPdfUseCase;
  };

export const getGenericCSVExportRepository =
  (): GenericCSVExportRepositoryImpl => {
    if (!_genericCSVExportRepository) {
      _genericCSVExportRepository = new GenericCSVExportRepositoryImpl();
    }
    return _genericCSVExportRepository;
  };

export const getExportGenericCSVUseCase = (): ExportGenericCSVUseCase => {
  if (!_exportGenericCSVUseCase) {
    _exportGenericCSVUseCase = new ExportGenericCSVUseCase(
      getGenericCSVExportRepository(),
    );
  }
  return _exportGenericCSVUseCase;
};

export const exportStudentRiskReportToPdfUseCase =
  (): ExportStudentRiskReportToPdfUseCase => {
    if (!_exportStudentRiskReportToPdfUseCase) {
      _exportStudentRiskReportToPdfUseCase =
        new ExportStudentRiskReportToPdfUseCase(
          academicRiskActionApiRepository,
        );
    }

    return _exportStudentRiskReportToPdfUseCase;
  };

export const resetExportContainer = (): void => {
  _pdfExportRepository = null;
  _exportToPdfUseCase = null;
  _exportActionDetailToPdfUseCase = null;
  _genericCSVExportRepository = null;
  _exportGenericCSVUseCase = null;
  _exportStudentRiskReportToPdfUseCase = null;
};
